import Icon from '../components/Icon.vue'

Icon.register({
  voicemail: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 128c79.5 0 144 64.5 144 144s-64.5 144-144 144h-352c-79.5 0-144-64.5-144-144 0-79.5 64.5-144 144-144s144 64.5 144 144c0 24.1-10.9 60-24.3 80h112.5c-13.4-20-24.3-55.9-24.3-80 0-79.5 64.5-144 144-144h0zM64 272c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zM496 352c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/voicemail.js
// module id = 2093
// module chunks = 0